/**
 * The chair app's tab bar and Today tiles draw from the one icon set (E05, `@cider/ui`): the same
 * Lucide paths at 20 × 20, carried in the bundle.
 */
import type { ReactNode } from 'react';
import { Glyph, type IconName } from '@cider/ui';

export type TabIcon = IconName;

export function TabGlyph({ name, className }: { name: TabIcon; className?: string }): ReactNode {
  return <Glyph name={name} className={className ?? 'app__glyph'} />;
}
